import React from 'react'
import { SettingsControlTile } from '../common'
import StyledSwitch from '@e3dc-react/shell/Elements/Switch/StyledSwitch'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useFormContext, useWatch } from 'react-hook-form'
import { Ai360SettingsFormValues } from '../../types'

/**
 * component to activate/deactivate AI360 feature
 */
const AI360SettingsControlTile: React.FC = () => {
  const { t } = useCustomTranslation()
  const { control, setValue } = useFormContext<Ai360SettingsFormValues>()
  const isAI360Active = useWatch({ control, name: 'isAI360Active' })

  const handleOnToggle = (): void => {
    const newValue = !isAI360Active
    // Mark field as dirty only when deactivating AI360, since activating it does not necessarily mean that the user has made changes to the sub-settings,
    setValue('isAI360Active', newValue, { shouldDirty: !newValue })
    if (newValue === false) {
      // reset all sub-settings to default value when deactivating AI360 to prevent invalid configuration
      setValue('isChargingFromPVActive', false)
      setValue('isChargingFromGridActive', false)
      setValue('isSGReadyActive', false)
      setValue('pvSettings.feedInTariffType', '')
    }
  }

  return (
    <SettingsControlTile
      title={t('ai360.settings-page.activate-ai360')}
      suffix={<StyledSwitch checked={isAI360Active} onChange={handleOnToggle} />}
    />
  )
}

export default AI360SettingsControlTile
